import { router } from '@inertiajs/svelte'

export function isSamePageIgnoringLocale(currentUrl, targetUrl) {
  const current = new URL(currentUrl, window.location.origin)
  const target = new URL(targetUrl, window.location.origin)

  // Compare pathnames
  if (current.pathname !== target.pathname) {
    return false
  }

  // Compare search params, excluding 'locale'
  const currentParams = new URLSearchParams(current.search)
  const targetParams = new URLSearchParams(target.search)

  currentParams.delete('locale')
  targetParams.delete('locale')

  return currentParams.toString() === targetParams.toString()
}
